import {
  CircularProgress,
  Typography
} from "@mui/material";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as yup from "yup";
import packagejson from "../../../package.json";
import LoginLayoutWrapper from "../commons/layout/LogginLayoutWrapper";
import { StyledLogin } from "../styled/Login";

const validationSchema = yup.object({
  username: yup
    .string()
    .max(100, "El campo no puede superar los 100 caracteres")
    .required("Campo obligatorio"),
  password: yup
    .string()
    .min(6, "La contraseña debe tener un mínimo de 6 caracteres")
    .max(32, "La contraseña debe tener un máximo de 32 caracteres")
    .required("Campo obligatorio"),
});

const initialValues = {
  username: "",
  password: "",
  version: packagejson.version,
};

const Login = ({ handleSubmit }) => {
  const loading = useSelector((state) => state.auth.loading);
  const activeToken = useSelector((state) => state.auth.activeToken);

  const loadingToken = activeToken ? activeToken.loading : false;

  return (
    <LoginLayoutWrapper>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        <StyledLogin.Form>
          <div>
            <StyledLogin.TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Usuario"
              name="username"
              autoFocus
              type="text"
            />
          </div>
          <div>
            <StyledLogin.Password
              variant="outlined"
              margin="normal"
              fullWidth
              name="password"
              label="Contraseña"
            />
          </div>
          <StyledLogin.Button
            color="primary"
            variant="contained"
            fullWidth
            type="submit"
            disabled={loading || loadingToken}
          >
            {loading || loadingToken ? (
              <CircularProgress size={24} thickness={4} color="primary" />
            ) : (
              "Ingresar"
            )}
          </StyledLogin.Button>
          <StyledLogin.ForgotPasswordContainer>
            <Link to="/recuperar-clave">
              <Typography>
                ¿Olvidaste tu contraseña?
              </Typography>
            </Link>
          </StyledLogin.ForgotPasswordContainer>
        </StyledLogin.Form>
      </Formik>
    </LoginLayoutWrapper>
  );
};

export default Login;
